export default function ContinuumBand({ className = "h-1", testid = "continuum-band" }) {
  return (
    <div
      data-testid={testid}
      role="presentation"
      aria-hidden="true"
      className={`w-full bg-continuum ${className}`}
    />
  );
}
